import { useState, useEffect } from "react";
import "./HomeIndustriesWeServe.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";

const HomeIndustriesWeServe = ({ currentLanguage = "en" }) => {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    heading: "INDUSTRIES WE SERVE",
    industries: [
      { img: "assets/icons/natural.png", title: "Natural Resources" },
      { img: "assets/icons/financial.png", title: "Financial Services" },
      { img: "assets/icons/health.png", title: "Healthcare" },
      { img: "assets/icons/lifescience.png", title: "Life Science" },
      { img: "assets/icons/privateequity.png", title: "Private Equity" },
      { img: "assets/icons/professional.png", title: "Professional Service" },
      { img: "assets/icons/public.png", title: "Public Sector" },
      { img: "assets/icons/lifescience.png", title: "Life Science" },
      { img: "assets/icons/privateequity.png", title: "Private Equity" },
      { img: "assets/icons/professional.png", title: "Professional Service" },
      { img: "assets/icons/public.png", title: "Public Sector" },
    ],
    stats: [
      { value: "250+", label: "Successful Businesses" },
      { value: "15+", label: "Experienced Professionals" },
      { value: "100+", label: "Strategic Advisory Projects" },
      { value: "1200+", label: "Satisfied Clients Worldwide" },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    heading: "SECTEURS QUE NOUS SERVONS",
    industries: [
      { img: "assets/icons/natural.png", title: "Ressources naturelles" },
      { img: "assets/icons/financial.png", title: "Services financiers" },
      { img: "assets/icons/health.png", title: "Santé" },
      { img: "assets/icons/lifescience.png", title: "Sciences de la vie" },
      { img: "assets/icons/privateequity.png", title: "Capital-investissement" },
      { img: "assets/icons/professional.png", title: "Services professionnels" },
      { img: "assets/icons/public.png", title: "Secteur public" },
      { img: "assets/icons/lifescience.png", title: "Sciences de la vie" },
      { img: "assets/icons/privateequity.png", title: "Capital-investissement" },
      { img: "assets/icons/professional.png", title: "Services professionnels" },
      { img: "assets/icons/public.png", title: "Secteur public" },
    ],
    stats: [
      { value: "250+", label: "Entreprises accompagnées" },
      { value: "15+", label: "Professionnels expérimentés" },
      { value: "100+", label: "Projets de conseil stratégique" },
      { value: "1200+", label: "Clients satisfaits dans le monde" },
    ],
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { heading, industries, stats } = data;

  // ================= CAROUSEL LOGIC =================
  const [activeIndex, setActiveIndex] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(7);

  const updateItemsPerSlide = () => {
    const width = window.innerWidth;
    if (width >= 1200) setItemsPerSlide(7);
    else if (width >= 992) setItemsPerSlide(5);
    else if (width >= 768) setItemsPerSlide(4);
    else setItemsPerSlide(2);
  };

  useEffect(() => {
    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);
    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const slides = chunkArray(industries, itemsPerSlide);

  // ================= JSX =================
  return (
    <section className="home-ourprocess-section position-relative">
      <div className="text-center">
        <h2 className="mb-5 home-ourprocess-section-head-industires">
          {heading}
        </h2>

        <Carousel
          className="industry-carousel"
          indicators={false}
          controls={false}
          interval={2500}
          pause={false}
          activeIndex={activeIndex}
          onSelect={(i) => setActiveIndex(i)}
        >
          {slides.map((group, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <div className="row justify-content-center g-3 industries-row">
                {group.map((item, index) => (
                  <div className="col-auto" key={index}>
                    <div className="process-card text-center gradient-border">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="process-icon"
                      />
                      <p className="process-text mt-2">{item.title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>

        <div className="home-ourprocess-section-custom-indicators mt-0">
          {slides.map((_, idx) => (
            <span
              key={idx}
              className={`home-ourprocess-section-indicator-dot ${
                activeIndex === idx
                  ? "home-ourprocess-section-active-indicator"
                  : ""
              }`}
            />
          ))}
        </div>
      </div>

      {/* YELLOW STATS BOX */}
      <div className="yellow-stats-box">
        <div className="row text-center">
          {stats.map((stat, index) => (
            <div key={index} className="col-6 col-md-3 stats-item">
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeIndustriesWeServe;
